import styled from 'styled-components';

export interface IContainer {
  marginLeft?: string;
}

export const Container = styled.span<IContainer>`
    margin-right: 5px;
    border: 1px solid #ccc;
    padding: 1px 5px;
    font-size: 0.8em;
    border-radius: 8px;
    margin-top: 2px;
    margin-left: ${props => props.marginLeft || '0px'};
`

export const Title = styled.span`
    font-weight: bold;
    font-size: 0.9em;
    color: #888;
`

export const Text = styled.span`
    color: #444;
`